module.exports = __webpack_public_path__ + "static/img/role-fr.7860902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/role-fr.png
// module id = PQbL
// module chunks = 1